import FormField from "../form-field";
import CheckboxesInput from "../inputs/checkboxes-input";
import RadioInput from "../inputs/radio-input";

export default class RadioField extends FormField {
	constructor(props) {
		super(props);

		this.radioInput = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('RadioField: Root element is not defined!');
		}

		this.radioInput = new RadioInput({
			$root: this.$root.querySelector('[data-input="radio"]')
		});

		super.init();
	}

	addEventListeners() {
		this.radioInput.subscribe('valueChange', this.handleValueChange.bind(this));
	}

	handleValueChange(e) {
		this.setValue(e.detail);
		this.validateSoft();
	}

	validate() {
		this.isValid = this.value !== null;
	}

	setInitialState() {
		this.radioInput.uncheckAll();
	}

	checkOption(value) {
		this.radioInput.checkOption(value);
	}
}